import { BZ2_EDIT_FILLOUT_MISSING_PROPS, EDIT_PRODUCT_SUBMIT_BUTTON } from 'mk/autogenerated/translations/EditProduct.d485ecd39d16c4ff4031c3329ce1069f'
import { canEditProducts, canManageBazaar, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { getPropertiesForCategories } from 'mk/bazaar/product/categories';
import ProductCreateEditForm, {
    ProductFormData,
    PRODUCT_CREATE_EDIT_FORM_NAME,
} from 'mk2/apps/bazaar/components/ProductCreateEditForm';
import { Props as PageProps } from 'mk2/apps/bazaar/containers/EditProduct/EditProductPage';
import { paramsToSlug } from 'mk2/apps/bazaar/helpers';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import React from 'react';
import styles from './EditProduct.mscss';

// We dont want to pass category and properties from Page because it leads to unnecessary re-renders
// they are used only in the header to disable submit button
type Props = Pick<PageProps, Exclude<keyof PageProps, 'category' | 'properties'>>;

export class EditProduct extends React.Component<Props> {

    private submitButton: React.ReactNode = (
        <SubmitButton label={EDIT_PRODUCT_SUBMIT_BUTTON} formName={PRODUCT_CREATE_EDIT_FORM_NAME} />
    );

    public render() {
        const { loadingState, product } = this.props;

        return (
            <div className={styles.EditProduct}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.onLoad}
                    onRenderSuccess={this.renderSuccess}
                    hasData={Boolean(product)}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const {
            initialValues,
            requestUser,
            selectedProperty,
            onSelectProperty,
            correctedFields,
            onSelectCategory,
            selectedCategory,
            requestUserPermissions,
            product,
            qualityCounts,
            currentValues,
            isMobile,
        } = this.props;
        const category = product.properties.find((p) => p[0] === 'cat')[1];
        const propertiesForCategory = getPropertiesForCategories([category]);
        const hasMissingProps = propertiesForCategory.reduce(
            (acc, cur) => acc || !initialValues.properties[cur] || initialValues.properties[cur].length === 0,
            false,
        );

        // Ordering:
        //  - is my product -> i am seller
        //  - admin -> when I am admin and moderator -> admin has precedence
        //  - moderator
        //  - user
        const isMyProduct = isAuthenticatedAs(requestUser, product.seller.user);
        // const isAdmin = isMyProduct ? false : canManageBazaar(requestUserPermissions);
        const isAdmin = canManageBazaar(requestUserPermissions);
        const isModerator = isMyProduct || isAdmin ? false : canEditProducts(requestUserPermissions);

        return (
            <>
                {hasMissingProps && (
                    <AnnouncementBox
                        type={BoxType.Yellow}
                        message={BZ2_EDIT_FILLOUT_MISSING_PROPS}
                        hasDetailMessage={false}
                        marginLeft={isMobile ? 5 : undefined}
                        marginRight={isMobile ? 5 : undefined}
                    />
                )}

                <ProductCreateEditForm
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    initialValues={initialValues}
                    currentValues={currentValues}
                    onSave={this.onSave}
                    activePlan={product.seller.user.activePlan}
                    selectedProperty={selectedProperty}
                    onSelectProperty={onSelectProperty}
                    selectedCategory={selectedCategory}
                    onSelectCategory={onSelectCategory}
                    correctedFields={correctedFields}
                    submitButton={this.submitButton}
                    isModeratorEdit={isModerator}
                    isAdminEdit={isAdmin}
                    qualityCounts={{
                        ...qualityCounts,
                        [product.quality]: qualityCounts?.[product.quality] ? qualityCounts?.[product.quality] - 1 : 0,
                    }}
                />
            </>
        );
    };

    private onLoad = () => {
        const {
            onLoad,
            match: { params },
        } = this.props;
        onLoad(paramsToSlug(params));
    };

    private onSave = (values: ProductFormData) => {
        const { onSave, product } = this.props;
        onSave(product.id, values);
    };
}
